"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundException = void 0;
class NotFoundException extends Error {
}
exports.NotFoundException = NotFoundException;
//# sourceMappingURL=not-found-exception.js.map